export default {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 'bold',
    textTransform: 'lowercase',
}